import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import '../../App.css'
import HomePage from './HomePage';

function IndexPage({ menuIndex }: { menuIndex: number }) {
  return (
    <div >
      <main >
      <div className='flex flex-row fixed top-14 bottom-0 inset-x-0'>
        <IndexPageInner menuIndex={menuIndex} />
        </div>
      </main>
    </div>
  );
}

function IndexPageInner({ menuIndex }: { menuIndex: number }) {
  const { authState, oktaAuth } = useOktaAuth();

  if (!authState) {
    return <div>Error: Unable to determine authentication state.</div>;
  }

  if (authState.isPending) {
    return <div>Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    oktaAuth.signInWithRedirect();
    return null; // Render nothing while redirecting
  }

  return (
  <HomePage menuIndex={menuIndex} />
  );
}

export default IndexPage;
